import { defineAsyncComponent } from 'vue';

export default {
    emits: ['dy-sort', 'dy-unfold', 'dy-action'],
    components: {
        dynamicTable: defineAsyncComponent(() => import('@/libraries/dynamictable/index.vue')),
        dyTh: defineAsyncComponent(() => import('@/libraries/dynamictable/th.vue')),
    },
    props: {
        dySortDefault: { type: Array, default: () => [] },
    },
    data: () => ({
        dynamic_table_unfolded: [],
        dynamic_table_data_uid_associated: {},
        dynamic_table_sort: [],
    }),
    created(){ this.dynamic_table_sort = this.dySortDefault; },
    methods: {
        dyEmit(action, data){ this.$emit('dy-action', {action, data}); },

        // Unfold
        dyIsUnfolded(id) { return this.dynamic_table_unfolded.indexOf(id) > -1; },
        dyUnfold(id){
            const pos = this.dynamic_table_unfolded.indexOf(id);
            if (pos > -1){
                this.dynamic_table_unfolded.splice(pos, 1);
                return false;
            }else{
                this.dynamic_table_unfolded.push(id);
                return true;
            }
        },
        dyForceUnfold(id){
            if(!this.dyIsUnfolded(id)) this.dynamic_table_unfolded.push(id);
        },
        dyBusy(id){ return this.dyUnfold("busy"+id); },
        dyIsBusy(id){ return this.dyIsUnfolded("busy"+id) },

        // Elements associated to uid
        dyHasUid(uid){ return this.dynamic_table_data_uid_associated[uid] !== undefined; },
        dyPushToUid(uid, data){ this.dynamic_table_data_uid_associated[uid] = data; },
        dyRemoveToUid(uid){ delete this.dynamic_table_data_uid_associated[uid]; },
        dyGetToUid(uid){ return this.dynamic_table_data_uid_associated[uid]; },

        // Generate sort data
        dyAddToSort(column, reset){
            const pos = this.dynamic_table_sort.indexOf(column);
            if(pos > -1){
                this.dynamic_table_sort.splice(pos, 1);
                if(reset) this.dynamic_table_sort = [];
                this.dynamic_table_sort.push('-'+column);
            } else {
                const pos = this.dynamic_table_sort.indexOf('-'+column);
                if(pos > -1){
                    if(reset) this.dynamic_table_sort = [];
                    else this.dynamic_table_sort.splice(pos, 1);
                }else{
                    if(reset) this.dynamic_table_sort = [];
                    this.dynamic_table_sort.push(column);
                }
            }
            this.$emit('dy-sort', this.dynamic_table_sort);
        }
    }
}
